import {
  call,
  CallEffect,
  cancel,
  put,
  SagaReturnType,
  select,
  takeEvery,
} from '@redux-saga/core/effects';
import { GlobalActions, GlobalPut } from '@ps20-frontend/shop-integration-redux';
import { App } from '@ps20-frontend/frontend-models';
import { Role, VermittlerFomRequestModel, VermittlerFomResponseModel } from '@ps20/bff-models';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { VtnrChangedActionPayload } from '../action-types/vtnrChangedActionPayload';
import { IAppState } from '../localStore';
import { CheckoutAction, CheckoutActions } from '../checkout.actions';

export const URL_MAPVERMITTLERFOM = '/privatschutz/api/fremdordnungsmerkmal';

export enum MAPVERMITTLERFOM_REQUEST_EVENTS {
  MAPVERMITTLERFOM_REQUEST_SUCCESSFUL = 'MAPVERMITTLERFOM_REQUEST_SUCCESSFUL',
  MAPVERMITTLERFOM_REQUEST_FAILED = 'MAPVERMITTLERFOM_REQUEST_FAILED',
}

export function* watchVermittlerFomMapping() {
  yield takeEvery(
    GlobalActions.VERMITTLER_NUMMER_CHANGED,
    safeSaga(vermittlerFomSaga, App.SHOP_CHECKOUT),
  );
  yield takeEvery(
    MAPVERMITTLERFOM_REQUEST_EVENTS.MAPVERMITTLERFOM_REQUEST_SUCCESSFUL,
    safeSaga(successCallback, App.SHOP_CHECKOUT),
  );
}

export function* vermittlerFomSaga(action: CheckoutAction<VtnrChangedActionPayload>) {
  const state: IAppState = yield select();
  if (state.transientState.role === Role.GENO || state.transientState.role === Role.OLB) {
    yield cancel();
  }
  const request: VermittlerFomRequestModel = {
    vermittlernummer: action.payload.vermittlernummer,
  };
  if (state.vermittler.selectedVermittlernummer && state.vermittler.fremd === true) {
    yield callBackend(request);
  }
}

export function callBackend(
  request: VermittlerFomRequestModel,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
): CallEffect<SagaReturnType<any>> {
  const globalPut = GlobalPut.getInstance();
  return call(
    globalPut.put.bind(globalPut),
    new GlobalActions().doRequest({
      appId: App.SHOP_CHECKOUT,
      body: request,
      url: URL_MAPVERMITTLERFOM,
      successEvent: MAPVERMITTLERFOM_REQUEST_EVENTS.MAPVERMITTLERFOM_REQUEST_SUCCESSFUL,
      errorEvent: MAPVERMITTLERFOM_REQUEST_EVENTS.MAPVERMITTLERFOM_REQUEST_FAILED,
    }),
  );
}

export function* successCallback(successAction: CheckoutAction<VermittlerFomResponseModel>) {
  yield put({
    type: CheckoutActions.VERMITTLER_FOM_RESPONSE_MAPPED,
    payload: {
      vermittlernummerWithFom: successAction.payload.vermittlernummerWithFom,
    },
  });
}
